<div *ngIf="displayError" >
  <span class="glyphicon glyphicon-remove form-control-feedback fix-error-icon"></span>
  <span class="sr-only">(error)</span>
  <div class="error-msg">
    <p id="msgError" *ngIf="!errors && errorMsg">{{ errorMsg }}</p>
    <p *ngFor="let error of getErrors()">{{ error }}</p>
  </div>
</div>
